window.StripeProcesses = {
	cardForm : function(form){
		MyWindow.awake();
		var $form	= $(form);
		var hash	= $form.find('input[name=hash]').val();
		jQuery.data(document.body, 'consumer', $form.find('input[name=consumer]').val());
		
		var options = {
			title		: Loc.g('Paiement sécurisé avec Stripe'),
			width		: 500,
			height		: 500,
			buttons : [
				{
					text : Loc.g("Payer"), 
					click : function(){
						$('#payment-form').submit();
					}
				},
				{
					text : Loc.g("Annuler"), 
					click : function(){
						MyWindow.close();
					}
				},
			],
			callback	: function(){
				Stripe.setPublishableKey(jQuery.data(document.body, 'consumer'));
				
				$('#payment-form').bind('submit', function(event) {
					var $form = $(this);
					// Disable the submit button to prevent repeated clicks
					MyWindow.addOption("buttons", []);
					MyWindow.addOption("buttons", []);
					
					$form.find('button').prop('disabled', true);
					
					Stripe.card.createToken($form, StripeProcesses.responseHandler);

					// Prevent the form from submitting with the default action
					return false;
			  });				
			}
		};
		
		var windowOpts = {action : "cardForm", hash : hash};
		MyWindow.load("stripe", windowOpts, options);
		
		return false;
	},
	
	responseHandler: function(status, response) {
		var $form = $('#payment-form');
		var buttons = [
			{
				text: Loc.g("Annuler"),
				click: function() {
					MyWindow.close();
				}
			},
			{
				text: Loc.g("Payer"),
				click: function() {
					$('#payment-form').submit();
				}
			},
		];

		if (response.error) {
			// Show the errors on the form
			$form.find('.payment-errors').text(response.error.message).show();
			MyWindow.addOption("buttons", buttons);

		} else {
			// token contains id, last4, and card type
			var token = response.id;
			// Insert the token into the form so it gets submitted to the server
			$form.unbind('submit');

			var options = {
				data: {action: 'process', stripeToken: token},
				dataType: "json",
				success: function(data) {
					if(data.status === 'success'){
						Utils.relocate('/buy/summary?status='+data.status+'&payid='+data.payid);
					}else{
						Utils.relocate('/buy/summary?status='+data.status);
					}
					MyWindow.awake();
				}
			};

			MyForm.prepare('payment-form', 'stripe', options, true);
			// and re-submit
			$form.submit();
		}
	},
	  
	chargeCard : function(elt){
		var $form = $(elt);
		var hash = $form.find('input[name=hash]').val();

		$.ajax({
			url : '/stripe',
			type : 'POST',
			data : {action : 'processCharge', hash : hash},
			dataType : 'json',
			beforeSend : function(){
				MyWindow.wait();
			},
			success : function(data){
				if(data.status === 'success'){
					Utils.relocate('/buy/summary?status='+data.status+'&payid='+data.payid);
				}else{
					StripeProcesses.cardForm(elt);
				}
			}
		});
		return false;
	},
	
	
	fingerprintForm : function(consumer){
		jQuery.data(document.body, 'consumer', consumer);
		
		var options = {
			title		: Loc.g('Stripe'),
			width		: 500,
			height		: 500,
			buttons : [
				{
					text: Loc.g("Annuler"),
					click: function() {
						MyWindow.close();
					}
				},
				{
					text : Loc.g("Enregistrer les informations de paiement"), 
					click : function(){
						$('#payment-form').submit();
					}
				},
			],
			callback	: function(){
				Stripe.setPublishableKey(jQuery.data(document.body, 'consumer'));
				
				$('#payment-form').bind('submit', function(event) {
					var $form = $(this);
					// Disable the submit button to prevent repeated clicks
					MyWindow.addOption("buttons", []);
					MyWindow.addOption("buttons", []);
					
					$form.find('button').prop('disabled', true);
					
					Stripe.card.createToken($form, StripeProcesses.responseFingerprintHandler);

					// Prevent the form from submitting with the default action
					return false;
			  });				
			}
		};
		
		var windowOpts = {action : "fingerprintForm"};
		MyWindow.load("stripe", windowOpts, options);
		
		return false;		
	},
	
	
	responseFingerprintHandler: function(status, response) {
		var $form = $('#payment-form');
		var buttons = [
			{
				text: Loc.g("Annuler"),
				click: function() {
					MyWindow.close();
				}
			},
			{
				text: Loc.g("Enregistrer les informations de paiement"),
				click: function() {
					$('#payment-form').submit();
				}
			}
		];

		if (response.error) {
			// Show the errors on the form
			$form.find('.payment-errors').text(response.error.message).show();
			MyWindow.addOption("buttons", buttons);

		} else {
			// token contains id, last4, and card type
			var token = response.id;
			// Insert the token into the form so it gets submitted to the server
			$form.unbind('submit');

			var options = {
				data: {action: 'switchUSD', stripeToken: token},
				dataType: "json",
				success: function(data) {
					Utils.relocate('/buy?action=switchUSDConfirm&status='+data.status);
					MyWindow.awake();
				}
			};

			MyForm.prepare('payment-form', 'stripe', options, true);
			// and re-submit
			$form.submit();
		}
	}
};